export const KEY_LABEL_FONT_COLOR = 'labelFontColor';
export const KEY_LABEL_FONT_SIZE = 'labelFontSize';
export const KEY_LABEL_FONT_STYLE = 'labelFontStyle';
export const KEY_LABEL_FONT_WEIGHT = 'labelFontWeight';
export const KEY_LABEL_STICK_TO = 'labelStickTo';
export const KEY_LABEL_TEXT_DECORATION = 'labelTextDecoration';
export const KEY_LABEL_TEXT_TRANSFORM = 'labelTextTransform';

export const KEY_SELECTION_COLOR = 'selectionColor';

export const KEY_TEXT_OPTION_FONT_COLOR = 'textOptionFontColor';
export const KEY_TEXT_OPTION_FONT_FAMILY = 'textOptionFontFamily';
export const KEY_TEXT_OPTION_FONT_SIZE = 'textOptionFontSize';
export const KEY_TEXT_OPTION_FONT_STYLE = 'textOptionFontStyle';
export const KEY_TEXT_OPTION_FONT_WEIGHT = 'textOptionFontWeight';
export const KEY_TEXT_OPTION_TEXT_DECORATION = 'textOptionTextDecoration';
export const KEY_TEXT_OPTION_TEXT_TRANSFORM = 'textOptionTextTransform';

export const KEY_TEXT_QUESTION_FONT_COLOR = 'textQuestionFontColor';
export const KEY_TEXT_QUESTION_FONT_FAMILY = 'textQuestionFontFamily';
export const KEY_TEXT_QUESTION_FONT_SIZE = 'textQuestionFontSize';
export const KEY_TEXT_QUESTION_FONT_STYLE = 'textQuestionFontStyle';
export const KEY_TEXT_QUESTION_FONT_WEIGHT = 'textQuestionFontWeight';
export const KEY_TEXT_QUESTION_TEXT_DECORATION = 'textQuestionTextDecoration';
export const KEY_TEXT_QUESTION_TEXT_TRANSFORM = 'textQuestionTextTransform';

export const KEY_TEXT_STATIC_FONT_COLOR = 'textStaticFontColor';
export const KEY_TEXT_STATIC_FONT_FAMILY = 'textStaticFontFamily';
export const KEY_TEXT_STATIC_FONT_SIZE = 'textStaticFontSize';
export const KEY_TEXT_STATIC_FONT_STYLE = 'textStaticFontStyle';
export const KEY_TEXT_STATIC_FONT_WEIGHT = 'textStaticFontWeight';
export const KEY_TEXT_STATIC_TEXT_DECORATION = 'textStaticTextDecoration';
export const KEY_TEXT_STATIC_TEXT_TRANSFORM = 'textStaticTextTransform';

export const KEY_TEXTFIELD_BACKGROUND_COLOR = 'textfieldBackgroundColor';
export const KEY_TEXTFIELD_BORDER_COLOR = 'textfieldBorderColor';
export const KEY_TEXTFIELD_BORDER_RADIUS = 'textfieldBorderRadius';
export const KEY_TEXTFIELD_BORDER_STYLE = 'textfieldBorderStyle';
export const KEY_TEXTFIELD_BORDER_WIDTH = 'textfieldBorderWidth';
export const KEY_TEXTFIELD_FONT_COLOR = 'textfieldFontColor';
export const KEY_TEXTFIELD_FONT_SIZE = 'textfieldFontSize';
export const KEY_TEXTFIELD_FONT_STYLE = 'textfieldFontStyle';
export const KEY_TEXTFIELD_FONT_WEIGHT = 'textfieldFontWeight';
export const KEY_TEXTFIELD_TEXT_DECORATION = 'textfieldTextDecoration';
export const KEY_TEXTFIELD_TEXT_TRANSFORM = 'textfieldTextTransform';

export const KEY_BUTTON_BACKGROUND_COLOR_KEY = 'buttonBackgroundColor';
export const KEY_BUTTON_BORDER_COLOR_KEY = 'buttonBorderColor';
export const KEY_BUTTON_BORDER_RADIUS_KEY = 'buttonBorderRadius';
export const KEY_BUTTON_BORDER_STYLE_KEY = 'buttonBorderStyle';
export const KEY_BUTTON_BORDER_WIDTH_KEY = 'buttonBorderWidth';
export const KEY_BUTTON_FONT_COLOR_KEY = 'buttonFontColor';
export const KEY_BUTTON_FONT_SIZE_KEY = 'buttonFontSize';
export const KEY_BUTTON_FONT_STYLE_KEY = 'buttonFontStyle';
export const KEY_BUTTON_FONT_WEIGHT_KEY = 'buttonFontWeight';
export const KEY_BUTTON_TEXT_DECORATION_KEY = 'buttonTextDecoration';
export const KEY_BUTTON_TEXT_TRANSFORM_KEY = 'buttonTextTransform';
